var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('div',{attrs:{"id":"container"}},[_c('v-skeleton-loader',{staticClass:"image",attrs:{"loading":_vm.loading,"type":"image","max-width":450,"max-height":500}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }